import {prevAll, nextAll} from "./utilities/functions";

function selectPrevAndNextStars(star) {
    const prevAllStars = prevAll(star);
    const nextAllStars = nextAll(star);

    for (const i of prevAllStars) {
        i.classList.add("rating__star--active");
    }

    for (const i of nextAllStars) {
        i.classList.remove("rating__star--active");
    }
}

function selectActiveStars(stars, value = 0) {
    let activeStar = false;
    for (const star of stars) {
        if (parseInt(star.dataset.value) === parseInt(value)) {
            activeStar = star;
            star.classList.add("rating__star--active");
        }
    }
    selectPrevAndNextStars(activeStar);
}

export function initRatingStars(wrapper = document) {
    for (const starsWrapper of wrapper.querySelectorAll(".js-setRatingGroup")) {
        const input = starsWrapper.querySelector('input');
        let activeValue = 0;
        let clickable = false;

        if (starsWrapper.classList.contains("clickable")) {
            clickable = true;
        }

        if (input) {
            const stars = starsWrapper.querySelectorAll('.js-setRating');
            activeValue = input.value;

            if (stars) {
                selectActiveStars(stars, activeValue);
                if (!clickable) {
                    for (const star of stars) {
                        star.addEventListener("click", function () {
                            star.classList.add("rating__star--active");
                            selectPrevAndNextStars(star);
                            input.value = star.dataset.value;
                        });
                    }
                }
            } else {
                console.error("stars not found");
            }
        } else {
            console.error("input not found");
        }
    }
}

export function initShowMoreRatings(query = document.querySelectorAll('.js-showMoreRatings')){
    for(const btn of query){
        const list = btn.closest('.ratingList');
        if(list){
            const items = list.querySelectorAll('.ratingListItem');
            if(items){
                btn.addEventListener("click",function (){
                    let count = 0;
                    for(const item of items){
                        if(count >= 5){
                            break;
                        }
                        if(item.classList.contains("hidden") && count < 5){
                            item.classList.remove("hidden");
                            count++;
                        }
                    }
                    if(list.querySelectorAll('.ratingListItem.hidden').length === 0){
                        btn.classList.add("hidden");
                    }
                });
            }
        }
    }
}